export default __webpack_public_path__ + "static/media/award-accent.38a9aefb.svg";